import {Record, List} from 'immutable';

import SimpleLogin from 'web-app/react/entities/common/simple-login';
import {type BodyMapLabel} from 'web-app/util/graphql/api-types';
import {hasValue} from 'web-app/util/typescript';
import {type FileFragment} from 'web-app/api/shared-fragments/__generated__/file.api-types';

import Employee from '../employees/model';
import BehaviorsCollection from '../../../behaviors/behaviors-collection';

export interface BodyMapPoint {
    bodyMapFile: {
        file: FileFragment;
        label: BodyMapLabel;
    };
    x: number;
    y: number;
    radius: number;
}
interface IReport {
    reportId: string | null;
    behaviors: BehaviorsCollection;
    createdBy: typeof SimpleLogin.default;
    date: string;
    description: string | null;
    firstAid: string | null;
    institutionId: string | null;
    kind: string | null;
    location: string | null;
    parentsNotified: string | null;
    note: string | null;
    staffPresent: List<typeof Employee.default>;
    time: string | null;
    witnesses: List<typeof Employee.default>;
    images: List<string>;
    files: List<{fileId: string; url: string; filename: string}>;
    acknowledged: {loginId: string; name: string; status: string; image: string} | null;
    acknowledgedAt: string | null;
    updatingAcknowledged: boolean;
    riddor: boolean;
    ofsted: boolean;
    lado: boolean;
    onArrival: boolean;
    childId: string | null;
    bodyMapPoints: Array<BodyMapPoint>;
}

const AccidentIncidentReport = Record<IReport>({
    reportId: null,
    behaviors: new BehaviorsCollection([]),
    createdBy: SimpleLogin.default,
    date: '',
    description: null,
    firstAid: null,
    institutionId: null,
    kind: null,
    location: null,
    parentsNotified: null,
    note: null,
    staffPresent: List(),
    time: null,
    witnesses: List(),
    images: List(),
    files: List(),
    acknowledged: null,
    acknowledgedAt: null,
    updatingAcknowledged: false,
    riddor: false,
    ofsted: false,
    lado: false,
    onArrival: false,
    childId: null,
    bodyMapPoints: [],
});

function fromAPI(data) {
    return new AccidentIncidentReport({
        ...data,
        behaviors: new BehaviorsCollection(data.behaviors),
        witnesses: List(data.witnesses).map(Employee.fromSimpleEmployeeAPI),
        staffPresent: List(data.staffPresent).map(Employee.fromSimpleEmployeeAPI),
        images: List(data.images),
        files: List(data.files),
        createdBy: SimpleLogin.fromAPI(data.createdBy),
        acknowledged: data.acknowledged ? SimpleLogin.fromAPI(data.acknowledged) : null,
        bodyMapPoints: hasValue(data.bodyMapPoints) ? data.bodyMapPoints : [],
    });
}

export default {
    record: AccidentIncidentReport,
    default: new AccidentIncidentReport(),
    fromAPI,
};
